import { ICityAsset, ICityLiteAsset } from "models/Assets/ICityAsset";
import {
  INeighborhoodAsset,
  INeighborhoodLiteAsset,
} from "models/Assets/INeighborhoodAsset";
import { AllowedCitiesTypes } from "contexts/AssetsContext";

export const filterCityByCityId = <T extends AllowedCitiesTypes>(
  cities: AllowedCitiesTypes[],
  cityId?: number | string
): T => {
  if (!cityId || !cities) return null;
  cityId = parseInt(String(cityId));
  const [city] = cities.filter((c) => c.id == cityId);
  return (city || null) as T;
};

export const filterCityByUrlName = <T extends AllowedCitiesTypes>(
  cities: AllowedCitiesTypes[],
  urlName?: string
): T => {
  if (!urlName || !cities) return null;
  const [city] = cities.filter(
    (c) => c.url_name_ar === urlName || c.url_name_en === urlName
  );
  return (city || null) as T;
};

export const filterNeighborhoodFromCitiesByNeighborhoodId = (
  cities: ICityAsset[] | ICityLiteAsset[],
  neighborhoodId?: number | string
): INeighborhoodAsset => {
  if (!neighborhoodId || !cities) return null;
  neighborhoodId = parseInt(String(neighborhoodId));

  let foundHood: INeighborhoodAsset = null;
  cities.forEach((city) => {
    if (!foundHood) {
      [foundHood = null] = (city?.pwaNeighborhoods || []).filter(
        (n) => n.id == neighborhoodId
      );
    }
  });

  return foundHood || null;
};

export const filterNeighborhoodByNeighborhoodId = <T>(
  neighborhoods: INeighborhoodLiteAsset[],
  neighborhoodId?: number | string
): T => {
  if (!neighborhoodId || !neighborhoods) return null;
  neighborhoodId = Number(neighborhoodId);

  const [nHood] = neighborhoods.filter((n) => n.id == neighborhoodId);

  return (nHood as unknown as T) || null;
};

export const filterNeighborhoodByNeighborhoodUrlName = <T>(
  neighborhoods: INeighborhoodLiteAsset[],
  urlName?: number | string
): T => {
  if (!urlName || !neighborhoods) return null;

  const [nHood] = neighborhoods.filter(
    (n) => n.url_name_ar == urlName || n.url_name_en == urlName
  );

  return (nHood as unknown as T) || null;
};
